import { render, staticRenderFns } from "./ToolLabel.vue?vue&type=template&id=10092585&scoped=true&"
var script = {}
import style0 from "./ToolLabel.vue?vue&type=style&index=0&id=10092585&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10092585",
  null
  
)

export default component.exports